<template>
    <div class="d-flex justify-content-between align-items-center">
      <div class="mt-4 mb-2">
        <img
            :src="file"
            class="file-image object-fit-contain"
            alt="Preview"
            height="53"
            width="71"
            ref="imagePreview"
            v-if="file && !file?.endsWith('.pdf')"
          />
        <a :href="href" target="_blank" rel="noopener noreferrer" :class="[ imagePreview ? 'px-3' : '', 'link-color' ]">
          <span :data-cy="datacy">{{ fileName }}</span>
        </a>
        <BaseTooltip placement="left" v-if="tooltipTitle || tooltipContent">
          <template #trigger>
            <i class="pi pi-info-circle icon-primary me-2 text-primary h5"/>
          </template>
          <template #content>
            <span>{{ tooltipTitle }}</span>
            <ul class="mt-2 mb-0">
              <li v-for="(item, index) in tooltipContent" :key="index">&#x2022; {{ item }}</li>
            </ul>
          </template>
        </BaseTooltip>
      </div>
    </div>
  </template>
  
  <script>
  import BaseTooltip from './BaseTooltip.vue';
  import { ref } from 'vue';
  export default {
    components: {
      BaseTooltip
    },
    props: {
      href: {
        // Omitted by callers that pass the whole `file` instead.
        type: String,
        required: false,
        default: ""
      },
      file:{
        // Either an upload object or a plain URL string, depending on whether
        // the file was just picked or came back from the API.
        type: [Object, String],
        required: false
      },
      datacy: {
        type: String,
        required: false
      },
      fileName: {
        type: String,
        required: true
      },
      tooltipTitle: {
        type: String,
        required: false
      },
      tooltipContent: {
        type: Array,
        required: false
      }
    }
    //image ref
    ,setup() {
      const imagePreview = ref(null);
      return {
        imagePreview
      };
    }
  }
  </script>
  
